import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { styled } from "@mui/material/styles";
import { RegistrationState } from "../../domain/registration";
import { pipe } from "fp-ts/function";
import { assertUnreachable } from "../../utils/assertUnreachable";

const Wrapper = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
}));

const ConfirmedState = () => (
    <Wrapper>
        <CheckCircleIcon color={"success"} />
        <Typography variant="button" marginLeft={1}>
            registrace potvrzena
        </Typography>
    </Wrapper>
);

const UnconfirmedState = () => (
    <Wrapper>
        <ErrorIcon color={"error"} />
        <Typography variant="button" marginLeft={1}>
            nezaplaceno
        </Typography>
    </Wrapper>
);

interface Props {
    state: RegistrationState;
}

export const RegistrationStateView = (p: Props) =>
    pipe(p.state, (state) => {
        switch (state) {
            case "confirmed":
                return <ConfirmedState />;

            case "unconfirmed":
                return <UnconfirmedState />;
        }

        assertUnreachable(state);
    });
